import {novelLemoncasualhub} from './novelLemoncasualhub.js';
import novelKeepreadingbook from './novelKeepreadingbook.js';
import countnovel from './countnovel.js'
export const appConfig = {
    novelLemoncasualhub,
    novelKeepreadingbook,
    countnovel,
    default: {
        lang: 'en',
        company: window.location.host,
        name: 'Deer Novel',
        email: 'al@opsarea.com',
        fbPixel: {
            1: '1438847163760449',
            2: '1789737104944898',
        },
        adx: {
            1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_1',
            2: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_2',
            3: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_3',
        },
        ga4: {
            id: 'G-FKN1JTRLD4'
        },
        adConfig: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 400,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 20,
        },
        content:{
            1: {
                split: '\n\n',
                textNum: 300,
                p: 3,
            },
        },
        pixelReport: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}